export default __webpack_public_path__ + "static/media/tdsd.f1c26d25.png";